<template>
   <v-container fluid fill-height class="loginBackground">
      <v-layout style="right:200px; position:absolute;" align-center>
        <v-card height="95%" class="" style="background:#ECF5FF; width:600px; min-height:800px">
            <v-alert
              type="error"
              min-height='50'
              icon='mdi-alert-circle'
              dismissible
              v-if="alert"
            >
              {{alertMessage}}
            </v-alert>
            <v-card-text>
              <div>
                <div style="margin-top:150px" class="contentCenter">
                  <img src="../assets/title_design.png" style="width:300px;" class="ml-auto mr-auto"/>
                </div>
                <v-toolbar-title
                  style="text-align:center;font-weight:500; color:black; font-size:250%;"
                >
                  AI智慧影像防護平台
                  <!-- {{$t('AI智慧影像防護')}} -->
                </v-toolbar-title>
                <v-form class="mt-5">
                  <div style='height:25px'><div v-show="isCapitalized">已啟用 Caps Lock</div></div>
                  <div style="width:70%; margin:0px auto;">
                    <div>
                      <v-text-field
                        label="帳號"
                        v-model="user"
                        name="user"
                        type="text"
                        class="rounded-lg"
                        outlined
                        v-on:keyup.enter="login"
                        @keyup="onHCapitalized($event)"
                        autofocus
                      ></v-text-field>
                      <v-text-field
                        label="密碼"
                        v-model="psw"
                        id="password"
                        class="rounded-lg"
                        name="password"
                        type="password"
                        outlined
                        v-on:keyup.enter="login"
                        @keyup="onHCapitalized($event)"
                        autocomplete="off"
                      ></v-text-field>
                    </div>
                    <v-btn
                      class="mainBtnColor rounded-lg white--text"
                      style="font-weight:bold;font-size:20px;width:100%;height:50px"
                      @click="login"
                    >
                      登入
                    </v-btn>
                  </div>
                </v-form>
              </div>
            </v-card-text>
            <v-spacer></v-spacer>
            <div
              class="ml-auto mr-auto mt-2"
              style="text-align:center;"
              v-show="enableLanguages"
            >
              <v-btn-toggle
                v-model="$store.state.lang"
                mandatory
                color="primary"
              >
                <v-btn
                  value='zh-TW'
                  style="font-weight:bold;"
                  @click="setLang('zh-TW')"
                >
                  中文
                </v-btn>
                <v-btn
                  value='ja-JP'
                  style="font-weight:bold;"
                  @click="setLang('ja-JP')"
                >
                  Jp
                </v-btn>
                <v-btn
                  value='en-US'
                  style="font-weight:bold;"
                  @click="setLang('en-US')"
                >
                  US
                </v-btn>
              </v-btn-toggle>
            </div>
        </v-card>
      </v-layout>
   </v-container>
</template>

<script>
import router from '../router'
import Service from '../service/service'
export default {
  name: 'Login',
  data: () => ({
    // rules: {
    //   account: [v => !!v || 'E-mail is required',
    //     v => /^[A-Za-z][12]\d{8}$/.test(v) || '身份證字號錯誤']
    // },
    img: '',
    user: '',
    psw: '',
    uuid: '',
    verification: '',
    alertMessage: '',
    alert: false,
    forgetPWDialog: false,
    account: '',
    dialogAlert: false,
    dialogAlertMessage: '',
    enableLanguages: false,
    loadedLanguages: [],
    isCapitalized: false
  }),
  computed: {
    rules () {
      return {
        account: [v => !!v || 'E-mail is required',
          v => /^[A-Za-z][12]\d{8}$/.test(v) || '身份證字號錯誤'] // 身份證字號錯誤
      }
    }
  },
  watch: {
    '$store.state.user': function (newVal) {
      if (newVal) {
        // console.log('test')
        const loginUser = JSON.parse(this.$store.getters.getUser)
        // 如果其他分頁完成登入則觸發將token放入sessionStorage並提供給axios使用
        sessionStorage.setItem('token', loginUser.token)
        // console.log('test')
        // console.log(this.$store.state.token)
        router.push(process.env.VUE_APP_API_MAIN_PAGE)
      }
    }
  },
  mounted: function () {
    this.enableLanguages = process.env.VUE_APP_API_multilang == 'true'

    if (this.$store.getters.getUser) {
      const loginUser = JSON.parse(this.$store.getters.getUser)
      switch (loginUser.roleId) {
        default: {
          router.push(process.env.VUE_APP_API_MAIN_PAGE)
          break
        }
      }
    } else {
      // this.getVierificationCode()
    }


  },
  methods: {
    onHCapitalized: function (event) {
      if (event.getModifierState) {
        this.isCapitalized = event.getModifierState('CapsLock')
      }
    },
    getVierificationCode () {
      Service.getVierificationCode()
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            // console.log('tset')
            this.showAlert('error', response.data.message)
          } else {
            this.img = 'data:image/png;base64,' + response.data.img
            this.uuid = response.data.uuid
            // console.log(this.img)
          }
        })
    },
    login: function () {
      var data = {
        user: this.user,
        psw: this.psw,
        uuid: this.uuid,
        verification: this.verification
      }
      Service.login(data)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
            // this.getVierificationCode()
          } else {
            // console.log(localStorage.getItem('accountLog'))
            const _user = response.data.data
            //_user.img = process.env.VUE_APP_API_URL1 + '/' + response.data.data.img
            this.$store.commit('login', JSON.stringify(_user))
          }
        })
    },
    forgetPW () {
      this.forgetPWDialog = true
    },
    cancel () {
      this.$refs.form.resetValidation()
      this.forgetPWDialog = false
      this.email = ''
    },
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    send () {
      if (this.$refs.form.validate()) {
        var parm = {
          account: this.account
        }
        const url = '/StaffList/ForgetPassword'
        Service.forgetPassword(parm, url)
          .then((response) => {
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.cancel()
            }
          })
      }
    },
    setLang (value) {
      console.log(this.enableLanguages)
      console.log(this.$store.state.lang, value)

      this.$store.commit('setLang', value)
      this.$i18n.locale = value
    },
  }
}
</script>
